function updateHeaderCartCountBubble(itemCount) {
  document.querySelectorAll('[id="cart-icon-bubble"], .header__icon--cart').forEach((cartIcon) => {
    let bubble = cartIcon.querySelector('.cart-count-bubble');

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      cartIcon.appendChild(bubble);
    }

    bubble.classList.toggle('hidden', itemCount === 0);

    bubble.innerHTML = `
      ${itemCount < 100 ? `<span aria-hidden="true">${itemCount}</span>` : ''}
      <span class="visually-hidden">Cart: ${itemCount} item${itemCount === 1 ? '' : 's'}</span>
    `;
  });
}

window.updateHeaderCartCountBubble = updateHeaderCartCountBubble;

function syncHeaderCartCountBubble() {
  return fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then((response) => response.json())
    .then((cart) => {
      updateHeaderCartCountBubble(cart.item_count);
      return cart;
    })
    .catch((error) => console.error('Cart count sync failed:', error));
}

function scheduleHeaderCartCountSync() {
  [100, 350, 750, 1500, 3000, 5000].forEach((delay) => {
    window.setTimeout(syncHeaderCartCountBubble, delay);
  });
}

function isCartMutationRequest(input) {
  const url = typeof input === 'string' ? input : input?.url || '';

  return /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
}

document.addEventListener('submit', (event) => {
  if (event.target.matches('form[action*="/cart/add"], form[data-type="add-to-cart-form"]')) {
    scheduleHeaderCartCountSync();
  }
}, true);

document.addEventListener('click', (event) => {
  if (event.target.closest('[name="add"], button[type="submit"], .product-form__submit, .quick-add__submit')) {
    scheduleHeaderCartCountSync();
  }
}, true);

if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleHeaderCartCountSync);
}

['cart:updated', 'cart:added', 'cart:change', 'ajaxCart:updated', 'ajaxCart:added'].forEach((eventName) => {
  document.addEventListener(eventName, scheduleHeaderCartCountSync);
});

if (!window.__kimbladeCartCountFetchPatched) {
  window.__kimbladeCartCountFetchPatched = true;
  const originalFetch = window.fetch;

  window.fetch = function (...args) {
    const cartMutation = isCartMutationRequest(args[0]);

    return originalFetch.apply(this, args).then((response) => {
      if (cartMutation && response.ok) {
        scheduleHeaderCartCountSync();
      }

      return response;
    });
  };
}

if (!window.__kimbladeCartCountXHRPatched && window.XMLHttpRequest) {
  window.__kimbladeCartCountXHRPatched = true;
  const originalOpen = window.XMLHttpRequest.prototype.open;
  const originalSend = window.XMLHttpRequest.prototype.send;

  window.XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__kimbladeCartMutation = isCartMutationRequest(url);
    return originalOpen.call(this, method, url, ...rest);
  };

  window.XMLHttpRequest.prototype.send = function (...args) {
    if (this.__kimbladeCartMutation) {
      this.addEventListener('loadend', () => {
        if (this.status >= 200 && this.status < 400) {
          scheduleHeaderCartCountSync();
        }
      });
    }

    return originalSend.apply(this, args);
  };
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.bindOverlayClick();
    this.setHeaderCartIconAccessibility();
    this.ensureBodyUnlockObserver();
  }

  bindOverlayClick() {
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (!overlay || overlay.dataset.bound === 'true') return;

    overlay.addEventListener('click', this.close.bind(this));
    overlay.dataset.bound = 'true';
  }

  unlockPageScroll() {
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    document.body.style.position = '';
    document.documentElement.style.position = '';
    document.body.style.touchAction = '';
    document.documentElement.style.touchAction = '';
  }

  forceInactive() {
    this.classList.remove('active');
    this.classList.remove('animate');
    this.removeAttribute('open');
  }

  ensureBodyUnlockObserver() {
    if (this.closeStateObserver) return;

    this.closeStateObserver = new MutationObserver(() => {
      if (!this.classList.contains('active')) {
        this.unlockPageScroll();
      }
    });

    this.closeStateObserver.observe(this, {
      attributes: true,
      attributeFilter: ['class'],
    });

    this.bodyClassObserver = new MutationObserver(() => {
      if (!this.classList.contains('active') && document.body.classList.contains('overflow-hidden')) {
        this.unlockPageScroll();
      }

      if (this.classList.contains('active') && !document.body.classList.contains('overflow-hidden')) {
        this.forceInactive();
      }
    });

    this.bodyClassObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  setHeaderCartIconAccessibility() {
    document.querySelectorAll('[id="cart-icon-bubble"]').forEach((cartLink) => {
      if (cartLink.dataset.cartDrawerBound === 'true') return;

      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
      cartLink.dataset.cartDrawerBound = 'true';
    });
  }

  updateHeaderCartIcons(html) {
    const cartIconHTML = this.getSectionInnerHTML(html);

    document.querySelectorAll('[id="cart-icon-bubble"]').forEach((cartIcon) => {
      cartIcon.innerHTML = cartIconHTML;
    });

    this.setHeaderCartIconAccessibility();
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
    this.classList.add('animate', 'active');
});
   
    this.addEventListener(
  'transitionend',
  () => {
    if (!this.classList.contains('active')) return;

    const containerToTrapFocusOn = this.classList.contains('is-empty')
      ? this.querySelector('.drawer__inner-empty')
      : document.getElementById('CartDrawer');

    const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

    if (containerToTrapFocusOn && focusElement) {
      trapFocus(containerToTrapFocusOn, focusElement);
    }
  },
  { once: true }
);

    document.body.classList.add('overflow-hidden');
  }

close() {
  this.forceInactive();
  removeTrapFocus(this.activeElement);
  this.unlockPageScroll();
  document.dispatchEvent(new CustomEvent('cart:drawer:closed'));
}


  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      if (section.id === 'cart-icon-bubble') {
        this.updateHeaderCartIcons(parsedState.sections[section.id]);
        return;
      }

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    this.bindOverlayClick();
   setTimeout(() => {
  this.open();
});
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
